import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LandingPageComponent } from './landing-page.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [LandingPageComponent],
  imports: [CommonModule, RouterModule],
  exports: [LandingPageComponent],
})
export class LandingPageModule {}
